export default {
    methods: {
        getImage: function (path) {
            if (path.includes("http")) {
                return path;
            }
            let url = "https://988tech.sgp1.cdn.digitaloceanspaces.com/website/";
            return url + path;
        },
        getHomeImage: function (path) {
            if (path.includes("http")) {
                return path;
            }
            let url = "https://988tech.sgp1.cdn.digitaloceanspaces.com/website/";
            return url + path;
        },
    }
}
